import React, { FunctionComponent } from 'react'
import { Route, Routes } from 'react-router'
import { HostData } from '../Customer/Data'
import { useTypedSelector } from '../../redux/reducers'
import { IntelligenceHub } from './IntelligenceHub'
import { CustomerDetail } from './CustomerDetail'

interface Props {
  teamID: string
  hosts: HostData[]
}

export const IntelligenceHubContainer: FunctionComponent<Props> = props => {
  const hostStates = useTypedSelector(s => s.hosts)

  return (
    <Routes>
      <Route index element={<IntelligenceHub teamID={props.teamID} hosts={props.hosts} />} />
      <Route
        path=':customerID/*'
        element={<CustomerDetail teamID={props.teamID} hosts={props.hosts} hostStates={hostStates} />}
      />
    </Routes>
  )
}
